/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { SERVER_DATA, MS_BACKEND_DATA } from "../environments/server-data";
import { CUSTOM_APP_DATA } from "./app-data";
export const environment = {
  name: "qa",
  server: SERVER_DATA.qa,
  msServer: MS_BACKEND_DATA.qa,
  version: "0.0.0.0",
  config: {
    prodServerUrl: SERVER_DATA.qa,
    stripePublicKey:
      "pk_test_51I0jb2E37ASPoyVl2dMEmXWDLgBUuClW0HkKzX65tTeOwj5cRnew7q65n2slfCSYoI8OLjgU1CvBn4pwfl3vFn0B001iBCIKWU",
    razorpayPublicKey: "rzp_test_riQNSW1FBpP4Rh",
    razorpayPartnerPublicKey: "rzp_test_partner_IU7VfVWOPKl4xS",
    ...CUSTOM_APP_DATA,
  },
  imagePath: SERVER_DATA.qa + "/",
};
